import { useStore as s } from '../../hooks/use-store.js';
import { useIsoMorphicEffect as u } from '../use-iso-morphic-effect.js';
import { overflows as t } from './overflow-store.js';
function a(r, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return {
      containers: []
    };
  };
  var f = s(t),
    o = e ? f.get(e) : void 0,
    i = o ? o.count > 0 : !1;
  return u(function () {
    if (!(!e || !r)) return t.dispatch("PUSH", e, n), function () {
      return t.dispatch("POP", e, n);
    };
  }, [r, e]), i;
}
export { a as useDocumentOverflowLockedEffect };